import { DecodedTokenType, IPermissions } from "../types/AuthTypes";

export const parseTokenPermissions = (decodedToken: DecodedTokenType) => {
  const permissions: IPermissions = {
    user: {},
    org: {},
    unit: {}
  };

  if (
    decodedToken.hasOwnProperty("permissions") &&
    Array.isArray(decodedToken.permissions)
  ) {
    decodedToken.permissions.map(permission => {
      const permissionElements = permission.split(":");
      const permissionCategory = permissionElements[0] as "user" | "org" | "unit";
      const permissionName = permissionElements.splice(1).join(":"); // Covers case where the permission value includes a ":" character. (ie "category:permission:value")
      if (permissionCategory === "unit") {
        const unitType = String(permissionName.split(":")[1]);
        const orgName = String(permissionName.split(":")[0]);
        permissions.unit = {
        ...permissions.unit,
        [orgName]: unitType
      };
      } else {
      permissions[permissionCategory] = {
        ...permissions[permissionCategory],
        [permissionName]: true
      };
    }
    });
  }
  console.log("permissions", permissions)
  return permissions;
};
